export const Navigation = {
  DASHBOARD: '/',
  UPDATE_PASSWORD: '/update-password',
  NEW_PASSWORD: '/new-password',
  RESET_PASSWORD: '/reset-password',
  PAYMENT_HISTORY: '/payment-history',
  BASKET: '/basket',
  CONFIRM_EMAIL: '/confirmEmail',
  LOGIN: '/login',
  REGISTER: '/register',
  TERM_CGU: '/term-cgu',
  TERM_RGPD: '/term-rgpd',

  SIGNATURE: '/signature/:user',

  LOGOUT: '/logout',

  CONTRACTS_DETAILS: '/contracts/:id',
  CONTRACT_NEW: '/contracts/new',

  ADMIN: '/admin',
  ADMIN_TRANSLATION: 'admin/translations',
  ADMIN_TEMPLATES: 'admin/templates',
  ADMIN_COUPONS: 'admin/coupons',
  ADMIN_USERS: 'admin/users',
  ADMIN_SUPPLIERS: 'admin/suppliers',
  ADMIN_RFOS: 'admin/rfos',
  ADMIN_CERVED: 'admin/cerved',
  ADMIN_ORDER: 'admin/orders',
};
